import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('mgs_user');
    if (saved) {
      const parsed = JSON.parse(saved);
      setUser(parsed);
      // Verify session
      api.me().then(data => {
        if (data && data.user) {
          setUser(data.user);
        } else {
          setUser(null);
          localStorage.removeItem('mgs_user');
          localStorage.removeItem('mgs_token');
        }
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (phone, password) => {
    const result = await api.login(phone, password);
    if (result && result.user) {
      setUser(result.user);
      return { success: true };
    }
    return { error: result?.error || 'Erreur de connexion' };
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isGuide = user?.role === 'guide';
  const isPoolSupervisor = user?.role === 'pool_supervisor';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isGuide, isPoolSupervisor }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
